// extracted by mini-css-extract-plugin
export default {"reject":"PageApplication_reject__Cm8ZG","approve":"PageApplication_approve__DXvJQ","forRevision":"PageApplication_forRevision__l5UdO","inWork":"PageApplication_inWork__W21w1"};